import { EntityTypes } from '../temporary-data-table/components/MoveEntityButton'

export const isTheSameEntity = (entityA: EntityDto, entityB: EntityTypes): boolean => {
    return (
        entityA?.rowId === entityB?.rowId &&
        entityA?.nodeId === entityB?.nodeId &&
        entityA?.frontUuid === entityB?.frontUuid
    )
}
